<div class="remarks-select-button-container" #remarksSelectButtonContainer>
    <button mat-mini-fab  class="map-control-button" aria-label="SendRemark" [ngClass]="{'active': isPanelOpen()}" (click)="toggle()"
        [matTooltip]="'send-remark.title' | translate" matTooltipPosition="left"
       >
        <mat-icon fontSet="ngi" fontIcon="remarks"></mat-icon>
    </button>
</div>

<ng-template #remarksSelect>

    <div class="tmv-panel tt-remarks-select-pane" (@openClose.start)="onAnimationEventStart($event)"
        (@openClose.done)="onAnimationEventEnd($event)" [@openClose]="isOpen() ? 'open' : 'close'">
        <button matIconButton type="button" class="close" (click)="close()"
            matTooltipPosition="above"><mat-icon>close</mat-icon></button>

        <h4>{{'send-remark.title'|translate}}</h4>
        <div>
            <!-- <button class="item-option" (click)="setMapRemarksInteraction()" [disabled]="!canCommentMap"> -->
            <button class="item-option" [ngClass]="{disabled: !canCommentMap}"
                (click)="canCommentMap ? setMapRemarksInteraction():showCannotCommentMsg($event.target)">
                <mat-icon aria-label="map" class="">location_on</mat-icon>
                <div class="item-option-title">{{'send-remark.about_map.title'|translate}}</div>
                <div class="mat-body-medium">{{'send-remark.about_map.content'|translate}}</div>
                 <a style="margin-top:9px;" mat-stroked-button >Go...</a>             
            </button>
            <div style="padding: 5px 5px 10px 40px;">
                <!-- [ngClass]=""  -->
                <!-- <a color="accent" aria-label="Show Remarks on Map" (click)="toggleRemarksLayer()"
                    [matTooltip]="'send-remark.showRemarksLayer' | translate" matTooltipPosition="below">
                   
                <mat-checkbox (click)="$event.preventDefault()" [checked]="isRemarksLayerVisible"></mat-checkbox>
                      {{'send-remark.show-remarks-on-map'|translate}}
                </a>     -->

                <!-- $event.checked -->
                <mat-checkbox class="show-remarks-on-map" (change)="toggleRemarksLayer()"
                    [checked]="isRemarksLayerVisible">
                    {{'send-remark.show-remarks-on-map'|translate}}
                </mat-checkbox> 

                <!-- <mat-divider></mat-divider> -->
            </div>
            <button class="item-option" (click)="showEmailForm()">
                <mat-icon aria-label="email">email</mat-icon>
                <div class="item-option-title">{{'send-remark.about_app.title'|translate}}</div>
                <div class="mat-body-medium">{{'send-remark.about_app.content'|translate}}</div>
                 <a style="margin-top: 9px;" mat-stroked-button color="">Go...</a>
            </button>
            <br>
            <br>
        </div>
    </div>
</ng-template>